import { render, staticRenderFns } from "./UnidentifiedObject.vue?vue&type=template&id=3562ba3e&scoped=true&"
import script from "./UnidentifiedObject.vue?vue&type=script&lang=js&"
export * from "./UnidentifiedObject.vue?vue&type=script&lang=js&"
import style0 from "./UnidentifiedObject.vue?vue&type=style&index=0&id=3562ba3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3562ba3e",
  null
  
)

export default component.exports